export default "__VITE_ASSET__Dq5WVKbS__"